import { FireIcon, SnowIcon } from "@hugeicons-pro/core-stroke-rounded";

export type GameRtpListVariant = "hot" | "cold";

type VariantStyle = {
  headerIcon: typeof FireIcon;
  bg: string;
};

const VARIANT_STYLES: Record<GameRtpListVariant, VariantStyle> = {
  hot: {
    headerIcon: FireIcon,
    bg: "bg-[#f76b15]",
  },
  cold: {
    headerIcon: SnowIcon,
    bg: "bg-[#2e69ff]",
  },
};

const computeVariantStyle = (variant: GameRtpListVariant): VariantStyle =>
  VARIANT_STYLES[variant];

export default computeVariantStyle;
